import React from 'react'
import './Footer.css'
import { Link } from 'react-router-dom'
import logo from '../Assets/logo.webp'

const Footer = () => {
  return (
    <footer className='footer'>
      <div className="footer-top">

        {/* Brand */}
        <div className="footer-brand">
          <img src={logo} alt="FORGE" className="footer-logo-img" loading="lazy" decoding="async" draggable={false} onContextMenu={e => e.preventDefault()} />
          <p className="footer-tagline">Engineered for performance.<br />Made for Indian conditions.</p>
          <div className="footer-socials">
            <a href="https://instagram.com" className="footer-social-link" aria-label="Instagram" target="_blank" rel="noreferrer">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
              </svg>
            </a>
            <a href="https://youtube.com" className="footer-social-link" aria-label="YouTube" target="_blank" rel="noreferrer">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
                <polygon fill="currentColor" points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"/>
              </svg>
            </a>
            <a href="https://wa.me/918888888888" className="footer-social-link" aria-label="WhatsApp" target="_blank" rel="noreferrer">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
            </a>
            <a href="https://x.com" className="footer-social-link" aria-label="X" target="_blank" rel="noreferrer">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.738l7.73-8.835L1.254 2.25H8.08l4.258 5.63 5.906-5.63Zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* SHOP */}
        <div className="footer-col">
          <h4>SHOP</h4>
          <ul>
            <li><Link to='/shop'>All Products</Link></li>
            <li><Link to='/shop'>Face Wash</Link></li>
          </ul>
        </div>

        {/* HELP */}
        <div className="footer-col">
          <h4>HELP</h4>
          <ul>
            <li><Link to='/faq'>FAQs</Link></li>
            <li><Link to='/shipping-policy'>Shipping &amp; Delivery</Link></li>
            <li><Link to='/return-refund-policy'>Returns &amp; Refunds</Link></li>
            <li><Link to='/orders'>Track Your Order</Link></li>
          </ul>
        </div>

        {/* LEGAL */}
        <div className="footer-col">
          <h4>LEGAL</h4>
          <ul>
            <li><Link to='/terms-and-conditions'>Terms of Service</Link></li>
            <li><Link to='/privacy-policy'>Privacy Policy</Link></li>
            <li><Link to='/return-refund-policy'>Refund Policy</Link></li>
            <li><Link to='/return-refund-policy'>Cancellation Policy</Link></li>
            <li><Link to='/grievance-redressal'>Grievance Redressal</Link></li>
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-col">
          <h4>CONTACT</h4>
          <ul>
            <li><Link to='/contact'>Contact Us</Link></li>
            <li><a href="mailto:support@forgeforskin.com">support@forgeforskin.com</a></li>
            <li><a href="https://wa.me/918888888888" target="_blank" rel="noreferrer">WhatsApp</a></li>
            <li><a href="tel:+918888888888">+91 88888 88888</a></li>
          </ul>
        </div>

      </div>

      <div className="footer-bottom">
        <hr />
        <p>© 2026 FORGE FOR SKIN™. All rights reserved.</p>
      </div>
    </footer>
  )
}

export default Footer
